import React from 'react'


export const Up = () => (
    <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
        <defs>
            <path id="qqww" d="M12 10.414l-5.293 5.293a1 1 0 1 1-1.414-1.414l6-6a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1-1.414 1.414L12 10.414z" />
        </defs>
        <g fill="none" fill-rule="evenodd">
            <mask id="asda12" fill="#fff">
                <use href="#qqww" />
            </mask>
            <g fill="#fff" mask="url(#asda12)">
                <path d="M0 0h24v24H0z" />
            </g>
        </g>
    </svg>
)